import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/guide-seating-chart";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/guides/how-to-make-a-wedding-seating-chart")({
  head: SEO["/guides/how-to-make-a-wedding-seating-chart"],
  component: () => <ContentPage path="/guides/how-to-make-a-wedding-seating-chart" body={body} />,
});
